<script lang="ts" setup>
import CategoryMenu from '@consumer/modules/support/CategoryMenu.vue'
</script>

<template>
  <V2PageTitle href="/support">Help Center</V2PageTitle>

  <div class="flex flex-col lg:flex-row py-6 lg:py-10 <lg:px-2 gap-6 max-w-screen-lg mx-auto">
    <div class="flex-1 w-full lg:flex-none lg:w-680px" data-qa="Support">
      <slot/>
    </div>

    <div class="w-full lg:w-320px lg:order-first">
      <CategoryMenu/>
    </div>
  </div>
</template>
